exports.components = {
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-templates-blog-jsx": () => import("./../../../src/templates/Blog.jsx" /* webpackChunkName: "component---src-templates-blog-jsx" */),
  "component---src-templates-page-jsx": () => import("./../../../src/templates/Page.jsx" /* webpackChunkName: "component---src-templates-page-jsx" */),
  "component---src-templates-single-post-page-jsx": () => import("./../../../src/templates/SinglePostPage.jsx" /* webpackChunkName: "component---src-templates-single-post-page-jsx" */)
}

